import { Link } from "react-router";
import { useRealm, useTurl } from "~/util/Lang";
import { CrystalColor } from "../item/Crystal";
import { Icon } from "../ui/Icon";

import css from "./Informer.module.css";

export function Informer() {
  const turl = useTurl();
  const { game } = useRealm();
  const grades =
    game === "c1" || game === "c2" || game === "c3" ? gradesC1 : gradesC4;
  return (
    <div>
      <div className={css.columnsThree}>
        <div className={css.panel}>
          <h2 className={css.panelTitle}>Weapons</h2>
          <ul>
            {weapons.map((weapon, i) => (
              <li key={i}>
                <div style={{ display: "flex", columnGap: 10 }}>
                  <Icon icon={weapon.icon} />
                  <Link
                    style={{ lineHeight: "32px", fontSize: 15 }}
                    to={turl(`/items/weapon?f=${weapon.type};canGet:true`)}
                  >
                    {weapon.name}
                  </Link>
                </div>
                <div className={css.gradeLine}>
                  {grades.map((grade, i) => (
                    <Link
                      className={css.gradeButton}
                      style={{ color: CrystalColor(grade.type) }}
                      to={turl(
                        `/items/weapon?f=grade:${grade.type};${weapon.type};canGet:true`
                      )}
                      key={i}
                    >
                      {grade.name}
                    </Link>
                  ))}
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className={css.panel}>
          <h2 className={css.panelTitle}>Armors</h2>
          <ul>
            {armors.map((armor, i) => (
              <li key={i}>
                <div style={{ display: "flex", columnGap: 10 }}>
                  <Icon icon={armor.icon} />
                  <Link
                    style={{ lineHeight: "32px", fontSize: 15 }}
                    to={turl(
                      `/items/${armor.path}?f=${armor.type};canGet:true`
                    )}
                  >
                    {armor.name}
                  </Link>
                </div>
                <div className={css.gradeLine}>
                  {grades.map((grade, i) => (
                    <Link
                      className={css.gradeButton}
                      style={{ color: CrystalColor(grade.type) }}
                      to={turl(
                        `/items/${armor.path}?f=grade:${grade.type};${armor.type};canGet:true`
                      )}
                      key={i}
                    >
                      {grade.name}
                    </Link>
                  ))}
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className={css.panel}>
          <h2 className={css.panelTitle}>Jewelry</h2>
          <ul>
            {jewels.map((jewelry, i) => (
              <li key={i}>
                <div style={{ display: "flex", columnGap: 10 }}>
                  <Icon icon={jewelry.icon} />
                  <Link
                    style={{ lineHeight: "32px", fontSize: 15 }}
                    to={turl(`/items/jewelry?f=${jewelry.type};canGet:true`)}
                  >
                    {jewelry.name}
                  </Link>
                </div>
                <div className={css.gradeLine}>
                  {grades.map((grade, i) => (
                    <Link
                      className={css.gradeButton}
                      style={{ color: CrystalColor(grade.type) }}
                      to={turl(
                        `/items/jewelry?f=grade:${grade.type};${jewelry.type};canGet:true`
                      )}
                      key={i}
                    >
                      {grade.name}
                    </Link>
                  ))}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className={css.columnsOne}>
        <div className={css.panelNpcs}>
          <h2 className={css.panelTitle}>NPCs</h2>
          <ul className={css.columnsThree}>
            {races.map((race, i) => (
              <li key={i}>
                <div
                  style={{
                    display: "flex",
                    columnGap: 5,
                    alignItems: "center",
                  }}
                >
                  <Icon icon={race.icon} size={16} />
                  <Link
                    style={{ fontSize: 15 }}
                    to={turl(`/npcs?f=${race.type}`)}
                  >
                    {race.name}
                  </Link>
                </div>
                <div className={css.levelLine}>
                  {levels.map((level, i) => (
                    <Link
                      className={css.levelButton}
                      to={turl(`/npcs?f=${race.type};${level.type}`)}
                      key={i}
                    >
                      {level.name}
                    </Link>
                  ))}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

const gradesC1 = [
  { name: "NG", type: "none" },
  { name: "D", type: "d" },
  { name: "C", type: "c" },
  { name: "B", type: "b" },
  { name: "A", type: "a" },
];

const gradesC4 = [
  { name: "NG", type: "none" },
  { name: "D", type: "d" },
  { name: "C", type: "c" },
  { name: "B", type: "b" },
  { name: "A", type: "a" },
  { name: "S", type: "s" },
];

const armors = [
  {
    name: "Robe",
    path: "armor",
    type: "at:magic",
    icon: "armor_tunic_of_devotion_i00",
  },
  {
    name: "Light",
    path: "armor",
    type: "at:light",
    icon: "armor_wooden_breastplate_i00",
  },
  {
    name: "Heavy",
    path: "armor",
    type: "at:heavy",
    icon: "armor_bronze_breastplate_i00",
  },
  {
    name: "Helmets",
    path: "armor",
    type: "slot:head",
    icon: "armor_leather_helmet_i00",
  },
  {
    name: "Gloves",
    path: "armor",
    type: "slot:gloves",
    icon: "armor_gloves_i00",
  },
  {
    name: "Boots",
    path: "armor",
    type: "slot:feet",
    icon: "armor_leather_sandals_i00",
  },
  {
    name: "Shields",
    path: "shield",
    type: "slot:lhand",
    icon: "shield_small_shield_i00",
  },
];

const weapons = [
  {
    name: "Swords",
    type: "wt:sword",
    icon: "weapon_small_sword_i00",
  },
  {
    name: "Blunts",
    type: "wt:blunt",
    icon: "weapon_club_i00",
  },
  {
    name: "Daggers",
    type: "wt:dagger",
    icon: "weapon_doomed_dagger_i00",
  },
  {
    name: "Bows",
    type: "wt:bow",
    icon: "weapon_hunting_bow_i00",
  },
  {
    name: "Fists",
    type: "wt:dualfist",
    icon: "weapon_vipers_canine_i00",
  },
  {
    name: "Pole",
    type: "wt:pole",
    icon: "weapon_short_spear_i00",
  },
  {
    name: "Duals",
    type: "wt:dual",
    icon: "weapon_dual_sword_i00",
  },
];

const jewels = [
  {
    name: "Necklaces",
    type: "slot:neck",
    icon: "accessary_necklace_of_magic_i00",
  },
  {
    name: "Earings",
    type: "slot:ear",
    icon: "accessary_apprentices_earing_i00",
  },
  {
    name: "Rings",
    type: "slot:finger",
    icon: "accessary_magic_ring_i00",
  },
];

const races = [
  { name: "Animals", icon: "skill4293", type: "race:animal" },
  { name: "Beasts", icon: "skill4292", type: "race:beast" },
  { name: "Bugs", icon: "skill4301", type: "race:bug" },
  { name: "Constructs", icon: "skill4291", type: "race:construct" },
  { name: "Demonic", icon: "skill4298", type: "race:demonic" },
  // { name: "Divine", icon: "", type: "" },
  { name: "Dragons", icon: "skill4299", type: "race:dragon" },
  { name: "Elementals", icon: "skill4296", type: "race:elemental" },
  { name: "Fairies", icon: "skill4302", type: "race:fairy" },
  // { name: "Giant", icon: "", type: "" },
  { name: "Humanoids", icon: "skill4295", type: "race:humanoid" },
  { name: "Plants", icon: "skill4294", type: "race:plant" },
  { name: "Undead", icon: "skill4290", type: "race:undead" },
  // { name: "Etc", icon: "", type: "" },
];

const levels = [
  { name: "1-9", type: "min:1;max:9&s=lvl" },
  { name: "10-19", type: "min:10;max:19&s=lvl" },
  { name: "20-29", type: "min:20;max:29&s=lvl" },
  { name: "30-39", type: "min:30;max:39&s=lvl" },
  { name: "40-49", type: "min:40;max:49&s=lvl" },
  { name: "50-59", type: "min:50;max:59&s=lvl" },
  { name: "60-69", type: "min:60;max:69&s=lvl" },
  { name: "70-79", type: "min:70;max:79&s=lvl" },
];
